import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DividendYield, DividendYieldTotal, NewsItem, PortfolioPerformance } from '@zero/shared/util-models';
import { ChartAndStats } from '../entities/chart-and-stats.entity';
import { Dividend } from '../entities/dividends.entity';
import { MyTrades } from '../entities/my-trades.entity';
import { Filter, Trade } from '../entities/trade.entity';
import { Weighting } from '../entities/weighting.entity';

export const StatisticsActions = createActionGroup({
  source: 'Statistics',
  events: {
    'Load Trade Ticker': emptyProps(),
    'Set Trade Ticker Loading': props<{ tradeTickerLoading: boolean }>(),
    'Subscribe To Trade Ticks': emptyProps(),
    'Subscribe To Trade Ticks Failure': emptyProps(),
    'Unsubscribe From Trade Ticks': emptyProps(),
    'Toggle Trade Ticker Filter': props<{ tradeTickerFilter: Filter }>(),
    'Push Trade Tick': props<{ trade: Trade }>(),
    'Load My Trades': emptyProps(),
    'Load Weighting By Asset Type': emptyProps(),
    'Load Weighting By Top Positions': emptyProps(),
    'Load Weighting By Positions': emptyProps(),
    'Load My News': emptyProps(),
    'Set News Loading': props<{ loading: boolean }>(),
    'Load Chart And Stats': props<{ force: boolean }>(),
    'Set Charts And Stats Loading': props<{ loading: boolean }>(),
    'Change Chart Period': props<{ from: Date; to: Date }>(),
    'Subscribe To Performance': emptyProps(),
    'Push Performance': props<{ performance: PortfolioPerformance }>(),
    'Load Dividends': emptyProps(),
    'Load Dividend Yields': props<{ force: boolean }>(),
    'Load Dividend Yield Total By Position': props<{ isin: string }>(),
    'Clear Dividend Yield Total By Position': emptyProps(),
  },
});

export const StatisticsApiActions = createActionGroup({
  source: 'Statistics API',
  events: {
    'Load Trade Ticker Success': props<{ trades: Trade[] }>(),
    'Load Trade Ticker Failure': props<{ error: HttpErrorResponse }>(),
    'Load My Trades Success': props<{ myTrades: MyTrades }>(),
    'Load My Trades Failure': props<{ error: HttpErrorResponse }>(),
    'Load Weighting By Asset Type Success': props<{ weightingByAssetType: Weighting }>(),
    'Load Weighting By Asset Type Failure': props<{ error: HttpErrorResponse }>(),
    'Load Weighting By Top Positions Success': props<{ weightingByTopPositions: Weighting }>(),
    'Load Weighting By Top Positions Failure': props<{ error: HttpErrorResponse }>(),
    'Load Weighting By Positions Success': props<{ weightingByPositions: Weighting }>(),
    'Load Weighting By Positions Failure': props<{ error: HttpErrorResponse }>(),
    'Load My News Success': props<{ news: NewsItem[] }>(),
    'Load My News Failure': props<{ error: HttpErrorResponse }>(),
    'Load Chart And Stats Success': props<{ chartAndStats: ChartAndStats }>(),
    'Load Chart And Stats Failure': props<{ error: HttpErrorResponse }>(),
    'Load Dividends Success': props<{ dividends: Dividend[] }>(),
    'Load Dividends Failure': props<{ error: HttpErrorResponse }>(),
    'Load Dividend Yields Success': props<{ dividendYields: DividendYield[] }>(),
    'Load Dividend Yields Failure': props<{ error: HttpErrorResponse }>(),
    'Load Dividend Yield Total By Position Success': props<{ dividendYieldTotal: DividendYieldTotal }>(),
    'Load Dividend Yield Total By Position Failure': props<{ error: HttpErrorResponse }>(),
  },
});
